import { FC, ReactNode } from 'react';
import { SpaceProps } from 'styled-system';
import { Flex, Box, Text } from 'roo-ui/components';
import Divider from 'components/payments/primitives/Divider';
import { FormattedMoney } from 'components/Formatters';
import { Money } from 'types';
import { NonWrappingText } from 'components/Typography';

interface TotalLineItemProps extends SpaceProps {
  title: ReactNode;
  totals: Money[];
  strong?: boolean;
}

const strongStyles = {
  color: 'greys.charcoal',
  fontSize: 'lg',
  fontWeight: 'bold',
};

const lightStyles = {
  color: 'greys.steel',
  fontSize: 'lg',
};

const shouldAddDivider = (array: any[], index: number) => index + 1 < array.length;

const TotalLineItem: FC<TotalLineItemProps> = ({ title, totals, strong, ...rest }) => (
  <Flex justifyContent="space-between" alignItems="baseline" {...rest}>
    <Box pr={5}>
      <Text {...(strong ? strongStyles : lightStyles)}>{title}</Text>
    </Box>
    <Box flex="0 0 auto">
      <Box textAlign="right">
        {totals.map((moneyProps, index) => (
          <Text key={`currency_${index}`} {...(strong ? strongStyles : lightStyles)}>
            <NonWrappingText>
              <FormattedMoney {...moneyProps} />
            </NonWrappingText>
            {shouldAddDivider(totals, index) && <Divider />}
          </Text>
        ))}
      </Box>
    </Box>
  </Flex>
);

export default TotalLineItem;
